import React from "react";

export default function ProfileSettingsDisplay() {
  return (
    <>
      <h4 className="mb-17 font-14-NunitoSans-600">User name</h4>
      <h5 className="mb-38 font-18-nunito-light color-white-66">TecHZEs</h5>
      <h4 className="mb-17 font-14-NunitoSans-600">Password</h4>
      <h5 className="mb-38 font-18-nunito-light color-white-66">
        Last changed 21 days ago
      </h5>
    </>
  );
}
